import React from 'react'
import ReactDOM from 'react-dom'
import SVG from 'react-inlinesvg'
import cartIcon from 'images/cart-badge.svg' // in app/assets

export const PORTAL_ID = 'header-cart-link'

export default class CartIcon extends React.Component {
  constructor(props) {
    super(props)

    this.renderTarget = document.getElementById(PORTAL_ID)
    this.renderTarget.innerHTML = ''
  }

  static defaultProps = {
    items: []
  }

  render() {
    const { items } = this.props

    const quantity = items.length === 1 ? 'item' : 'items'
    const label = `View your cart. Your cart has ${items.length} ${quantity}.`

    return ReactDOM.createPortal(
      <React.Fragment>
        <SVG
          src={cartIcon}
          width="28"
          className="stroke-current"
          height="28"
          aria-hidden="true"
          aria-label="cart"
          focusable="false"
          data-has-items={items.length > 0}
        />
        <span className="sr-only">{label}</span>
      </React.Fragment>,
      this.renderTarget
    )
  }
}
